import React, { useEffect } from "react";
import {
  Portal,
  Message,
  MessageHeader,
  MessageContent,
} from "semantic-ui-react";
import { connect } from "react-redux";

import { snackbarRemoveMessage } from "../../actions/snackbar";
import "./snackbar.css";

function Toast({ message, closeSnackbarMessage }) {
  const { id, header, content, ...props } = message;
  const snackbarId = `snackbar-${id}`;

  useEffect(() => {
    if (message.duration === 0) return;
    const timeout = setTimeout(dismiss, message.duration || 6000);
    return () => clearTimeout(timeout);
  }, []);

  function dismiss() {
    // add closing animation before unmounting
    document.getElementById(snackbarId).classList.add("closing");
    setTimeout(() => closeSnackbarMessage(id), 150);
  }

  return (
    <div id={snackbarId} className="snackbar-message-container">
      <Message
        {...props}
        className="snackbar-message"
        style={{ "--snackbar-color": props.color }} // default is blue info color
      >
        <MessageHeader>
          <div>{header}</div>
          <div>
            <i className="delete icon" onClick={dismiss}></i>
          </div>
        </MessageHeader>
        <MessageContent>{content}</MessageContent>
      </Message>
    </div>
  );
}

function Snackbar(props) {
  const { snackbar: messages = [], closeSnackbarMessage } = props;

  return (
    <Portal open>
      <div className="snackbar">
        {messages.map((message) => (
          <Toast
            key={message.id}
            message={message}
            closeSnackbarMessage={closeSnackbarMessage}
          />
        ))}
      </div>
    </Portal>
  );
}

const mapStateToProps = (state) => {
  return {
    snackbar: state.snackbar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeSnackbarMessage: (messageId) => {
      dispatch(snackbarRemoveMessage(messageId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);



// WEBPACK FOOTER //
// ./src/components/snackbar/snackbar.js